import React, { useState } from 'react';
import { IntlProvider } from 'react-intl';
import { SupportedLanguage } from 'Common/types';
import enMessages from '../../lang/en.json';
import deMessages from '../../lang/de.json';
import esMessages from '../../lang/es.json';
import zuMessages from '../../lang/zu.json';

type Messages = { [index: string]: string };

type LocaleContextType = {
  locale: string;
  selectLanguage: (locale: string) => void;
};

export const LocaleContext = React.createContext<LocaleContextType>({
  locale: localStorage.getItem('locale') || 'DE',
  selectLanguage: () => {},
});

const availableMessages: Record<SupportedLanguage, Messages> = {
  EN: enMessages,
  DE: deMessages,
  ES: esMessages,
  ZU: zuMessages,
};

const OwnIntlProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const defaultLocale = localStorage.getItem('locale') || 'DE';
  const lang = availableMessages[defaultLocale as SupportedLanguage];
  const [locale, setLocale] = useState(defaultLocale);
  const [currentMessages, setMessages] = useState(lang);

  const selectLanguage = (newLocale: string) => {
    setLocale(newLocale);
    const temp = availableMessages[newLocale as SupportedLanguage];
    setMessages(temp);
  };

  return (
    <LocaleContext.Provider value={{ locale, selectLanguage }}>
      <IntlProvider messages={currentMessages} locale={locale}>
        {children}
      </IntlProvider>
    </LocaleContext.Provider>
  );
};

export default OwnIntlProvider;
